const IYDRegistrationHeader = ({ step, totalSteps = 2 }) => {
  return (
    <div className="mb-6 text-center">
      <h2 className="text-2xl md:text-3xl lg:text-[40px] leading-[150%] tracking-[-2%] text-white">
        Registration <span className="italic font-medium text-[#B9FB02]">Form</span>
      </h2>
      <p className="mt-1 text-base md:text-lg lg:text-xl text-white">
        {step}/{totalSteps}
      </p>
    </div>
  );
};

export default IYDRegistrationHeader;